export default {
  getNestedChildren (arr, parent) {
    var out = []
    for (var i in arr) {
      if (arr[i].parent_id === parent) {
        var children = this.getNestedChildren(arr, arr[i].id)
        if (children.length) {
          arr[i].children = children
        } else {
          arr[i].children = []
        }
        out.push(arr[i])
      }
    }
    return out
  },

  getUnNestedChildren (object = {}) {
    object = Object.assign({}, object)
    var outs = [object]
    if (object.children) {
      for (var i = 0; i < object.children.length; i++) {
        outs = this.arrayUnique(outs.concat(outs.concat(object.children[i], this.getUnNestedChildren(object.children[i]))))
      }
    }
    return outs
  },

  arrayUnique (array) {
    var a = array.concat()
    for (var i = 0; i < a.length; ++i) {
      for (var j = i + 1; j < a.length; ++j) {
        if (a[i].id === a[j].id) { a.splice(j--, 1) }
      }
    }
    return a
  },

  getDiff (past = [], now = []) {
    return this.arrayUnique(past.concat(now))
  },

  findWithAttr (array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
      if (array[i][attr] === value) {
        return i
      }
    }
    return -1
  },
  getParent (id, data) {
    var output = []
    var parent = data[this.findWithAttr(data, 'id', id)].parent_id
    while (parent) {
      output.push(data[this.findWithAttr(data, 'id', parent)])
      parent = data[this.findWithAttr(data, 'id', parent)].parent_id
    }
    return output
  }
}



// WEBPACK FOOTER //
// ./src/views/tag/Helper.js